import { Action } from 'redux';
import { isType } from 'typescript-fsa';
import { asyncActions as editStartActions } from './actions/Shipment.edit.start.action';
import { asyncActions as editSubmitActions } from './actions/Shipment.edit.submit.action';
import { ErrorWrapper } from 'store/base';

export const REDUCER_KEY__SHIPMENT = 'shipment';

export class ShipmentState {
  type?: string;
  errorWrapper?: ErrorWrapper;
  shipmentId?: string;
  loading: boolean;
}

const defaultState: ShipmentState = {
  loading: false,
};
export default (state: ShipmentState = defaultState, action: Action): ShipmentState => {
  // Edit actions
  if (isType(action, editStartActions.started)) {
    return { ...state, type: action.type, loading: true };
  }
  if (isType(action, editStartActions.done)) {
    return { type: action.type, shipmentId: action.payload.result.shipmentId, ...defaultState };
  }
  if (isType(action, editStartActions.failed)) {
    return { ...state, type: action.type, loading: false, errorWrapper: action.payload.error };
  }

  // Edit actions submit
  if (isType(action, editSubmitActions.started)) {
    return { ...state, type: action.type, loading: true, errorWrapper: undefined };
  }
  if (isType(action, editSubmitActions.done)) {
    return { ...state, type: action.type, loading: false };
  }
  if (isType(action, editSubmitActions.failed)) {
    return { ...state, type: action.type, errorWrapper: action.payload.error, loading: false };
  }

  return state;
};
